import(/* webpackMode: "eager" */ "/app/src/app/(ru)/blog/page.tsx");
